module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    class: _vm.homepage == true ? 'l-home' : ''
  }, [_c('custom-toolbar', {
    attrs: {
      "modifier": "white-content"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), _c('v-ons-toolbar-button', {
    attrs: {
      "slot": "left",
      "modifier": "white-content",
      "id": "menu_btn"
    },
    on: {
      "click": function($event) {
        return _vm.$store.commit('splitter/toggle');
      }
    },
    slot: "left"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16"
    }
  }, [_c('g', {
    attrs: {
      "id": "Groupe_174",
      "data-name": "Groupe 174",
      "transform": "translate(-288 -22)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Menu",
      "d": "M-6160,14V12h10v2Zm0-6V6h16V8Zm0-6V0h16V2Z",
      "transform": "translate(6448 23)",
      "fill": _vm.homepage == true ? '#fff' : '#475056'
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle_1446",
      "data-name": "Rectangle 1446",
      "width": "16",
      "height": "16",
      "transform": "translate(288 22)",
      "fill": "none"
    }
  })])])])], 1), _vm._v(" "), _c('v-ons-tabbar', {
    attrs: {
      "position": "bottom",
      "swipeable": "",
      "modifier": _vm.md ? 'autogrow grey-content' : '',
      "on-swipe": _vm.onSwipe,
      "tabs": _vm.tabs,
      "index": _vm.index
    },
    on: {
      "update:index": function($event) {
        _vm.index = $event
      }
    }
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('v-ons-tab', {
      key: index,
      attrs: {
        "icon": tab.icon,
        "label": _vm.$t(tab.label)
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b522416","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/AppTabbar.vue
// module id = 222
// module chunks = 0